import React from "react";
import { Button, ButtonGroup, Popover } from "@walmart-web/livingdesign-components";
import styles from "./feedbacktags.module.css";
import { feedbackTags } from "../../store/constants";

const FeedbackTags = ({ selectedBtns }: { selectedBtns: (index: number) => void }) => {
  const [state, setState] = React.useState(Array(feedbackTags.length).fill(false));
  const [buttonSelected, setButtonSelected] = React.useState(
    Array(feedbackTags.length).fill(false)
  );
  const ref: any = React.useRef();

  const handleTagClick = (index: number) => {
    selectedBtns(index);
    let newState = buttonSelected.slice();
    newState[index] = !buttonSelected[index];
    setButtonSelected(newState);
  };
  const negateCurrentState = (close: boolean, index: number) => {
    let newState = state.slice();
    newState[index] = !state[index];
    if (close) {
      newState[index] = false;
    }
    setState(newState);
  };
  return (
    <div className={styles.feedbackTagsParent}>
      <div className={styles.tagHeader}>Please choose appropriate tags:</div>
      <div className={styles.feedbackTagsButtons}>
        <ButtonGroup UNSAFE_className={styles.tagsGroup}>
          {feedbackTags.map((tag, index) => (
            <Popover
              content={<div className={styles.tagDefinition}>{tag.definition}</div>}
              UNSAFE_className={styles.tagHoverContainer}
              key={`${tag?.tag}-${index}`}
              onClose={() => setState(Array(feedbackTags.length).fill(false))}
              isOpen={state[index]}
              triggerRef={ref}
              hasNubbin={true}
              basePopoverProps={{ className: "base-popover" }}
              position="topCenter"
            >
              <Button
                UNSAFE_className={`${styles.tagButton} ${buttonSelected[index] ? styles.solid : ""}`}
                onClick={() => handleTagClick(index)}
                size="small"
                onMouseEnter={() => negateCurrentState(false, index)}
                onMouseLeave={() => negateCurrentState(true, index)}
                variant="secondary"
              >
                <div ref={ref} className={styles.tagWidth}>
                  {tag?.tag}
                </div>
              </Button>
            </Popover>
          ))}
        </ButtonGroup>
      </div>
    </div>
  );
};

export default FeedbackTags;
